/**
 * @generated SignedSource<<b727408e429e8d7882270c1e4527e3af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleListArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleDividerArticle" | "articleFooterArticle" | "articlePaginationCheckerArticle" | "articlePaginationNavigationHistoryArticle" | "articlePaywallCheckerContent" | "articleRecommendationArticle" | "articleRenderArticle" | "contextsArticleListContextProviderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersCheckIsPostiesArticle" | "helpersCheckIsStyleArticle" | "showTypeformArticle" | "topBannerContent">;
  readonly " $fragmentType": "articleListArticle";
};
export type articleListArticle$key = {
  readonly " $data"?: articleListArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleListArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleListArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topBannerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDividerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleFooterArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaginationCheckerArticle"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articlePaginationNavigationHistoryArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRecommendationArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaywallCheckerContent"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articleRenderArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": (v2/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": (v2/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextsContentReadMoreContextProviderContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "contextsArticleListContextProviderArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "showTypeformArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "579645f4f5cd0135693f8f48c71de456";

export default node;
